export default __webpack_public_path__ + "static/media/logo-payway-header.14ddcdaf.png";